<template>
  <info-tool-tip-help-popup class="amex-creds-help-popup"
    :title="'איך לחבר חשבון אמריקן אקספרס?'"
    :cx-dude="{ name: 'yael', displayName: 'יעל' }"
    :source-name="'אמריקן אקספרס'"
    :popup-name="'AmexCredsHelpPopup'"
    :on-close="onClose">
    <template v-slot:description>
      <div class="description">
        <div>
          כדי לחבר את האמריקן אקספרס ל-riseup צריך לספק למערכת את פרטי המשתמש הקבועים (כולל סיסמא קבועה)
         איתם נכנסים לאתר או לאפליקציה של אמריקן אקספרס.
        </div>
        <div>&nbsp;</div>
        <div class="bold">שכחת את שם המשתמש והסיסמא הקבועה?</div>
        אפשר לשחזר אותם <a target="_blank" rel="noopener noreferrer"
           href="https://he.americanexpress.co.il/personalarea/loginarea/#/ForgotPassword">בלינק הזה</a>
        <div>&nbsp;</div>
        <div class="bold">אין לך שם משתמש וסיסמא קבועה?</div>
        אפשר ליצור אותם <a target="_blank" rel="noopener noreferrer"
           href="https://he.americanexpress.co.il/personalarea/loginarea/#/Register">בלינק הזה</a>
      </div>
    </template>
  </info-tool-tip-help-popup>
</template>

<script>

import InfoToolTipHelpPopup from '../InfoToolTipHelpPopup.vue';

export default {
  name: 'AmexCredsHelpPopup',
  components: {
    InfoToolTipHelpPopup,
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@riseupil/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .amex-creds-help-popup {
    .description {
      a {
        color: $riseup_blue;
        font-weight: bold;
      }
      .bold {
        font-weight: bold;
      }
    }
  }

</style>
